import { queryClient } from './queryClient'
import { queryKeys } from './queryKeys'

/**
 * Domain-Driven Cache Invalidation Helpers
 *
 * One-line calls to synchronize all dependent tables, dropdowns,
 * approval counters, and dashboards across the entire app.
 */
export const invalidateEntity = {
  // Master Entities
  company: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.companies.all })
    queryClient.invalidateQueries({ queryKey: ['options', 'companies'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.all })
  },

  branch: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.branches.all })
    queryClient.invalidateQueries({ queryKey: ['options', 'branches'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.all })
  },

  department: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.departments.all })
    queryClient.invalidateQueries({ queryKey: ['options', 'departments'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.all })
  },

  role: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.roles.all })
    queryClient.invalidateQueries({ queryKey: ['options', 'roles'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.all })
  },

  user: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
    queryClient.invalidateQueries({ queryKey: ['options', 'users'] })
    queryClient.invalidateQueries({ queryKey: ['options', 'employees'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.allocation.all })
  },

  // Project Management
  project: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.pm.all })
    queryClient.invalidateQueries({ queryKey: ['options', 'projects'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  task: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.pm.tasks() })
    queryClient.invalidateQueries({ queryKey: ['options', 'tasks'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.allocation.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  job: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.pm.jobs() })
    queryClient.invalidateQueries({ queryKey: ['options', 'jobs'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.allocation.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  allocation: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.allocation.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  // Approvals
  approval: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.companies.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.branches.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.departments.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.roles.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.options.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  timesheet: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.pm.timesheets() })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.timesheet() })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  leaves: () => {
    queryClient.invalidateQueries({ queryKey: ['leaves'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.leaves() })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  supportTicket: () => {
    queryClient.invalidateQueries({ queryKey: ['support-tickets'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  payroll: () => {
    queryClient.invalidateQueries({ queryKey: ['payroll'] })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all })
  },

  productivity: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.productivity.all })
    queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.personal() })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.productivity() })
    queryClient.invalidateQueries({ queryKey: queryKeys.approval.all })
  },

  // Reset entire cache (e.g. on user logout)
  all: () => {
    queryClient.clear()
  },
}
